import { Logger } from '@thesavingsgroup/logger/Logger';
import type { GetRatesWithDelayDependencies } from './types/GetRatesWithDelayDependencies';
import type { GetRatesForBrandsParams } from './types/GetRatesForBrandsParams';
import type { GetRatesForBrandsResults } from './types/GetRatesForBrandsResults';
import { getRatesForBrands } from './getRatesForBrands';
import { getRateTableCached } from './getRateTableCached';

const DEFAULT_DELAY_IN_MS = 1000;

export const getRatesWithDelay =
  ({
    baseURL = import.meta.env.VITE_RATE_TABLE_BASE_URL,
    reporter,
    delay = DEFAULT_DELAY_IN_MS,
    fetcher = fetch,
    getRateTableFunction = getRateTableCached({ baseURL, fetcher, reporter }),
    logger = new Logger(),
  }: GetRatesWithDelayDependencies) =>
  ({
    creditScoreRange,
    downPayment,
    loanAmount,
    loanTerm,
    loanType,
  }: GetRatesForBrandsParams): Promise<GetRatesForBrandsResults> => {
    return getRatesForBrands(
      getRateTableFunction,
      logger,
    )({
      creditScoreRange,
      downPayment,
      loanAmount,
      loanTerm,
      loanType,
    }).then(
      (result: GetRatesForBrandsResults) =>
        new Promise((resolve) => setTimeout(() => resolve(result), delay)),
    );
  };
